/**
 * The signed-in "app surface" — the routes a native shell would wrap.
 *
 * These pages are the product a customer has already paid for, not marketing.
 * Third-party marketing tags have no business inside them: they are dead weight
 * on a phone (GTM, GA4 and Google Ads together are ~510 KB on /my-account,
 * measured on production), and on a mental-health product they also mean ad and
 * analytics vendors observing a clinical surface.
 *
 * Kept as one predicate rather than a `startsWith` scattered across files, so
 * "what counts as the app" cannot drift between the script tag in `_app` and the
 * noscript iframe in `_document`.
 *
 * Deliberately route-pattern based, not URL based: Next gives `router.pathname`
 * and `__NEXT_DATA__.page` without the locale prefix, so this needs no locale
 * handling and cannot be fooled by `/en/my-account/...`.
 *
 * NOT included: /experts, /expert/[slug] and checkout. They are part of the app
 * surface for bundle purposes, but they are also where acquisition is measured —
 * gtmViewCart/gtmBeginCheckout/gtmPurchase all fire there. Removing GTM from
 * them would silently break campaign attribution.
 */
export const isAppSurfaceRoute = (
  pathname: string | undefined | null,
): boolean =>
  !!pathname &&
  (pathname === '/my-account' || pathname.startsWith('/my-account/'))
